// These styles were ported over from previous vendors work and need to be validated
export default {
  root: {
    height: '1.6em',
    width: '1.6em',
  },
};
